import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, acceptAnalytics, declineAnalytics, onConsentReset } from '../lib/analytics';

// Asks before loading Google Analytics. Shown until the visitor chooses, and
// again if they click "Change cookie settings" on the privacy page.
const CookieBanner = () => {
  const [visible, setVisible] = useState(() => getConsent() === null);

  useEffect(() => onConsentReset(() => setVisible(true)), []);

  if (!visible) return null;

  const choose = (accept) => {
    if (accept) acceptAnalytics();
    else declineAnalytics();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 px-4 pt-4 bg-rebel-dark text-white shadow-lg"
      style={{ paddingBottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))' }}
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-sm text-gray-200 flex-1" style={{ maxWidth: 'none' }}>
          We'd like to use analytics cookies to see how people use this site. They are only
          set if you accept. See our <Link to="/privacy" className="underline">privacy policy</Link>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            type="button"
            onClick={() => choose(false)}
            className="px-4 py-2 rounded-lg border border-gray-400 text-sm font-medium hover:bg-white/10"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={() => choose(true)}
            className="px-4 py-2 rounded-lg bg-rebel-coral text-sm font-medium hover:opacity-90"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
